<template>
    <div class="bash-wrap industry-wrap">
            <div class="bash-box">
                <p class="h2-title">{{ indata.FirstTitle }}</p>
                <ul class="industry-ul">
                    <li v-for="(item, index) in indata.children":key="index"  >
                           <div><img :src="item.image" alt="" /></div>
                        <p>{{ item.title }}</p>
                    </li>
        
                </ul>
            </div>
        </div>
</template>
<style scoped src="../../public/css/drp.css">

</style>



<script>
export default {
  name: "Templates17",
  props: {
    indata: Array,
  },
  computed: {
  //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    }
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>


